import React, { useContext, useState } from 'react'
import { AppContext } from '../context/AppContext'
import styled from 'styled-components'

export default function LessonTabs({ lesson }) {
  const { appState } = useContext(AppContext)
  const [activeTab, setActiveTab] = useState(lesson.content ? 'CONTENT' : lesson.video && lesson.transcript ? 'TRANSCRIPT' : 'INFO')

  return (
    <div className="lesson-content-tabs">
      <LessonTabsList className="tabs">
        {lesson.content && (
          <LessonTab onClick={() => setActiveTab('CONTENT')} className={`tabs-title ${activeTab === 'CONTENT' ? 'is-active' : ''}`}>Content</LessonTab>
        )}
        {lesson.video && lesson.transcript && (
          <LessonTab onClick={() => setActiveTab('TRANSCRIPT')} className={`tabs-title ${activeTab === 'TRANSCRIPT' ? 'is-active' : ''}`}>Transcript</LessonTab>
        )}
        <LessonTab onClick={() => setActiveTab('INFO')} className={`tabs-title ${activeTab === 'INFO' ? 'is-active' : ''}`}>Lesson Info</LessonTab>
      </LessonTabsList>
      <TabContentWrapper className="tabs-content">
        {lesson.content && activeTab === 'CONTENT' && (
          <TabContent className={`tabs-panel is-active`}>
            <div className="lesson-content" dangerouslySetInnerHTML={{__html: lesson.content}} />
          </TabContent>
        )}
        {lesson.video && lesson.transcript && activeTab === 'TRANSCRIPT' && (
          <TabContent className={`tabs-panel is-active`}>
            <div className="lesson-transcript" dangerouslySetInnerHTML={{__html: lesson.transcript}} />
          </TabContent>
        )}
        {activeTab === 'INFO' && (
          <TabContent className={`tabs-panel is-active`}>
            <div className="lesson-info">
              {lesson.description && (
                <div className="lesson-info-item">
                  <h6 className="lesson-info-title">About This Course</h6>
                  <div className="lesson-description" dangerouslySetInnerHTML={{__html: lesson.description}}/>
                </div>
              )}
              {lesson.links && lesson.links.length > 0 && (
                <div className="lesson-info-item">
                  <h6 className="lesson-info-title">Links</h6>
                  <ul className="links">
                    {lesson.links.map((link, index) =>
                      <li key={link.link_url} className="link">
                        <a href="{{link.link_url}}" target="_blank">{link.link_name}</a>
                      </li>
                    )}
                  </ul>
                </div>
              )}
              {lesson.instructors && lesson.instructors.length > 0 ? (
                <div className="lesson-info-item">
                  {lesson.instructors.length > 1 ? (
                    <>
                      <h6 className="lesson-info-title">Lesson Instructors</h6>
                      <ul className="lesson-instructors">
                        {lesson.instructors.map((instructor) => (
                          <li key={instructor.name} className="lesson-instructor">{instructor.name}</li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <>
                      <h6 className="lesson-info-title">Lesson Instructor</h6>
                      <div className="lesson-instructor">{lesson.instructors[0].name}</div>
                    </>
                  )}
                </div>
              ) : appState.course.instructors && appState.course.instructors.length > 0 && (
                <div className="lesson-info-item">
                  {appState.course.instructors.length > 1 ? (
                    <>
                      <h6 className="lesson-info-title">Course Instructors</h6>
                      <ul className="lesson-instructors">
                        {appState.course.instructors.map((instructor) => (
                          <li key={instructor.name} className="lesson-instructor">{instructor.name}</li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <>
                      <h6 className="lesson-info-title">Course Instructor</h6>
                      <div className="lesson-instructor">{appState.course.instructors[0].name}</div>
                    </>
                  )}
                </div>
              )}
            </div>
          </TabContent>
        )}
      </TabContentWrapper>
    </div>
  )
}

const LessonTabsList = styled.ul`
  display: flex;
  justify-content: flex-start;
  list-style: none;
  margin: 0;
`

const LessonTab = styled.li`
  cursor: pointer;
`

const TabContentWrapper = styled.div`
  padding: 1rem;
`

const TabContent = styled.div`
  display: flex;
  flex-direction: column;
`